import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Result } from 'antd';

import { i18 } from '../../utilities';
import { Translate } from '../../components';
import { CreatePasswordForm } from '../createPassword/components';

const renderPartnerSuccess = () => (
    <Result
        status='success'
        title={<Translate value={i18.ResetSuccess.Titles.PasswordChanged} />}
        subTitle={<Translate value={i18.ResetSuccess.Labels.PartnerAppHint} />}
    />
);

export const PartnerCreatePasswordContainer = (props) => {
    const [created, setCreated] = useState(false);

    return (
        <div className='row public_wrapper'>
            <div className='col-12 align-self-center public_content'>
                <div className='public_inner_sm'>
                    {!created && (
                        <div className='public_title'>
                            <Translate value={i18.UserPasswordForm.Titles.Create} />
                        </div>
                    )}
                    <div className='public_reset_wrapper'>
                        <div className='public_reset_form'>
                            <CreatePasswordForm
                                {...props}
                                renderSuccess={renderPartnerSuccess}
                                onCreated={() => setCreated(true)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PartnerCreatePasswordContainer.propTypes = {
    match: PropTypes.object.isRequired
};
